import { Box, styled } from '@mui/material';
import { themeColors } from 'src/theme';
import Button from '../Button';
import Input from '../Input';

export const AcceptButton = styled(Button)(({ theme }) => ({
  backgroundColor: themeColors.green,
  color: themeColors.white,
  textTransform: 'capitalize',
  marginRight: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '200px',
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: themeColors.white,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(3, 4),
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const StyledDisabledInput = styled(Input)({
  pointerEvents: 'none',
  backgroundColor: themeColors.white,
  borderColor: themeColors.grayMedium,
  color: themeColors.black,
  '& input.Mui-disabled': {
    WebkitTextFillColor: themeColors.black,
  },
});
